import { mapKeys, camelCase, snakeCase } from 'lodash';
import { csrfFromDom } from 'common/utils/server';

export const SET_CATEGORY = 'SET_CATEGORY';
function setCategory(categoryToUpdate) {
  return { type: SET_CATEGORY, categoryToUpdate };
}

function categoryUpdateRequest(category) {
  const categoryToUpdate = { ...category, isLoading: true, error: false };
  return dispatch => dispatch(setCategory(categoryToUpdate));
}

function categoryUpdateSuccess(category) {
  const categoryToUpdate = { ...category, isLoading: false, error: false };
  return dispatch => dispatch(setCategory(categoryToUpdate));
}

function categoryUpdateError(category) {
  const categoryToUpdate = { ...category, isLoading: true, error: true };
  return dispatch => dispatch(setCategory(categoryToUpdate));
}

function updateCategory(category) {
  return function fetchData(dispatch) {
    const categoryRequest = mapKeys(category, (_, key) => snakeCase(key));
    dispatch(categoryUpdateRequest(category));

    return fetch(`/api/v1/coaching/takeaway_category/${category.id}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfFromDom(),
      },
      body: JSON.stringify(categoryRequest),
    })
      .then(response => response.json())
      .then(json => {
        const categoryResponse = mapKeys(json, (_, key) => camelCase(key));
        dispatch(categoryUpdateSuccess(categoryResponse));
      })
      .catch(error => {
        dispatch(categoryUpdateError(error));
      });
  };
}

export function toggleArchivedAndUpdate(category) {
  const categoryToUpdate = { ...category, archived: !category.archived };

  return dispatch => {
    dispatch(updateCategory(categoryToUpdate));
    dispatch(setCategory(categoryToUpdate));
  };
}
